import React, { useEffect, useState } from "react";
import { AssortGroup } from "../../../models/AssortGroup";
import useTicketsByAssortGroup from "./hooks/useTicketsByAssortGroup";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import { HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import { useTranslation } from "react-i18next";
import ReadMore from "../../../../features/ReadMore";
import LoadingSpinner from "../../../../features/Loading/LoadingSpinner";
import useCountHtmlTagCharacters from "../../../../utils/hooks/useCountHtmlTagCharacters";

interface IProps {
  item: AssortGroup;
  sortType: string;
}

const LimitedTicketBlock: React.FC<IProps> = ({ item, sortType }) => {
  const { t } = useTranslation();
  const {
    requestGetTicketsByAssortGroup,
    assorts,
    requestGetTicketsByColor,
    requestGetTicketsByShape,
    requestGetPassesByColor,
  } = useTicketsByAssortGroup();
  const [isLoading, showTickets] = useState(false);
  const { countHtmlTagCharacters } = useCountHtmlTagCharacters();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { getBasket } = useBasketManager();
  const lowestPrice = assorts.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);
  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
  };
  useEffect(() => {
    if (sortType === "assortGroup") {
      requestGetTicketsByAssortGroup(item.objectId);
    }
    if (sortType === "colorGroup") {
      requestGetTicketsByColor(item.objectDb, item.objectId);
    }
    if (sortType === "shapeGroup") {
      requestGetTicketsByShape(item.objectId);
    }
    if (sortType === "colorGroupPasses") {
      requestGetPassesByColor(item.objectId);
    }
  }, [item.objectId]);

  return (
    <React.Fragment>
      <div className="single-available-exercise shadow flex-between-center border">
        <div className="single-available-exercise-img" style={{ backgroundImage: `url(${item.pictureUrl})` }}></div>

        <div className="single-available-exercise-text readmore-left">
          <h2>{item.name}</h2>
       
            <article dangerouslySetInnerHTML={{ __html: item.description }}></article>
          
        </div>

        <div className="single-available-exercise-buttons flex-column">
          <b>
            {lowestPrice !== Infinity ? (
              <React.Fragment>
                {t("ceny_od")} {lowestPrice} {t("zl")}
              </React.Fragment>
            ) : (
              <LoadingSpinner />
            )}
          </b>
          <React.Fragment>
            {!isLoading && (
              <button className="button medium button-fill-main padding-medium" onClick={() => showTickets(!isLoading)}>
                <HiOutlineTicket className="icon" />
                {t("pokaz_bilety")} ({assorts.length})
              </button>
            )}
            {isLoading && (
              <button
                className="button medium button-outline-main padding-medium"
                onClick={() => showTickets(!isLoading)}
              >
                <HiOutlineTicket className="icon" />
                {t("schowaj_bilety")} ({assorts.length})
              </button>
            )}
          </React.Fragment>
        </div>
      </div>
      {isLoading && (
        <div className="limited-ticket-container">
          {assorts.map((itemTicket, index) => (
            <div className="ticket-line-container" key={index}>
              <TicketLineSummary
                item={itemTicket}
                preBasket={preBasket}
                addItemToBasket={addItemToBasket}
                removeItemFromBasket={removeItemFromBasket}
              />
            </div>
          ))}
          <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
        </div>
      )}

 
    </React.Fragment>
  );
};

export default LimitedTicketBlock;
